export const TestIds = {
  bgLayers: 'bgLayers',
  colorUnderlay: 'colorUnderlay',
  mediaPadding: 'mediaPadding',
  canvas: 'canvas',
} as const;
